module.exports = __webpack_public_path__ + "img/thumbnail-epsat-video.11831d1.jpg";